"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaTag = void 0;
const react_1 = __importDefault(require("react"));
const head_1 = __importDefault(require("next/head"));
const MetaTag = (props) => {
    const { contentType, productTitle, pageTitle, description, imageUrl, url, card = 'summary', metaTags = [] } = props;
    return (react_1.default.createElement(head_1.default, { "data-cy": 'meta-tag' },
        react_1.default.createElement("title", null, pageTitle),
        react_1.default.createElement("meta", { name: "title", content: productTitle }),
        react_1.default.createElement("meta", { name: "description", content: description }),
        react_1.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
        react_1.default.createElement("meta", { property: "og:title", content: productTitle }),
        react_1.default.createElement("meta", { property: "og:description", content: description }),
        react_1.default.createElement("meta", { property: "og:image", content: imageUrl }),
        contentType ? react_1.default.createElement("meta", { property: "og:type", content: contentType }) : null,
        url ? react_1.default.createElement("meta", { property: "og:url", content: url }) : null,
        react_1.default.createElement("meta", { property: "twitter:title", content: productTitle }),
        react_1.default.createElement("meta", { property: "twitter:description", content: description }),
        react_1.default.createElement("meta", { property: "twitter:image", content: imageUrl }),
        react_1.default.createElement("meta", { property: "twitter:card", content: card }),
        url ? react_1.default.createElement("meta", { property: "twitter:url", content: url }) : null,
        metaTags.map((metaData) => {
            return react_1.default.createElement("meta", Object.assign({ key: JSON.stringify(metaData) }, metaData));
        })));
};
exports.MetaTag = MetaTag;
__exportStar(require("./types"), exports);
